import { createSelector } from 'reselect';
import getDeliveryProvider from './getDeliveryProvider';
import getDeliveryAddress from './getDeliveryAddress';
import getDeliveryTime from './getDeliveryTime';
import getDeliveryNotes from './getDeliveryNotes';
import getDeliveryDetails from './getDeliveryDetails';
import combineAddressParts from '../utils/ordering/combineAddressParts';
import getBestEstId from './getBestEstId';

export interface IDeliverySaleBodyContentHttpDto {
    DeliveryTime: string;
    Address?: {
        StreetName: string;
        Suburb?: string;
        State?: string;
        Postcode?: string;
    };
    DeliveryProvider?: number;
    DeliveryNotes: string;
    BestEstID: number | null;
    BuildingInformation?: string;
    DeliveryInstructions?: DELIVERY_INSTRUCTION;
}

function createSubmissionAddress(address: TokenisedAddress | null) {
  if (!address) {
    return undefined;
  }

  const { unit, streetNumber, streetName, suburb, state, postcode } = address;

  return {
    StreetName: combineAddressParts([
      ...(streetNumber != null && unit != null
        ? [`${unit}/${streetNumber}`]
        : [unit, streetNumber]),
      streetName,
    ]),
    Suburb: suburb,
    State: state,
    Postcode: postcode,
  };
}

export default createSelector(
  [
    getDeliveryProvider,
    getDeliveryAddress,
    getDeliveryTime,
    getDeliveryNotes,
    getDeliveryDetails,
    getBestEstId,
  ],
  (
    deliveryProvider,
    deliveryAddress,
    deliveryTime,
    deliveryNotes,
    deliveryDetails,
    bestEstId
  ): IDeliverySaleBodyContentHttpDto => ({
    DeliveryTime: deliveryTime,
    Address: createSubmissionAddress(deliveryAddress),
    DeliveryProvider: deliveryProvider?.id,
    DeliveryNotes: deliveryNotes,
    BestEstID: bestEstId,
    BuildingInformation: deliveryDetails?.buildingInformation,
    DeliveryInstructions: deliveryDetails?.deliveryInstruction,
  }),
);
